import { useFlags as ldFlags } from 'launchdarkly-react-client-sdk';
import { FFProps } from '../models';

export const useFlags = (): FFProps => {
  const {
    blMaintenanceMode,
    v2ColorSchemes,
    v2Development,
    v2FieldWalkthroughs,
    v2Jobs,
    v2ManageTools,
    v2MapSetup,
    v2ModelHomes,
    v2Neighborhoods,
    v2Options,
    v2Parts,
    v2PhotoApproval,
    v2Plans,
    v2Possessions,
    v2ProductionChecklists,
    v2ProductionPunchlists,
    v2Reports,
    v2ScheduleTemplates,
    v2ShowBuildTools,
    v2Specs,
    v2Users,
    v2ShowTradePartnerContracts,
    v2SiteReports,
    zendeskAndHelpTools,
    entraId,
    salesClosingCalendar,
    underContract,
    clientViewBuild,
    clientBuildCreation,
    fwtManagement,
    contractMarkUp,
    homeownerClosingCeremonies,
    closingDateSageOverwrite,
    salesDigitalContracting,
    documentationBuildDocumentation,
    uniformLoginPage,
    unifiedUserManagement,
    bulkOptionExclusions,
    selectsPageSlidingMenus,
    salesTestBuild,
    salesAgentLookup,
    salesIncentiveRepeater,
    entraUserCreationOrigin,
    hidePlaceOrderPage,
    convertToEntraButton,
    createReturnPoButton,
    lotPremiumOptionDepositCalculation,
    manageAppRolesPage,
    authorizeUserNavigationAccess,
    fwtPlanMarkup,
    homeownerPortalV2,
    buildCommunicationsPage,
    warrantyQuestionPage
  } = ldFlags();

  return {
    blMaintenanceMode,
    v2ColorSchemes,
    v2Development,
    v2FieldWalkthroughs,
    v2Jobs,
    v2ManageTools,
    v2MapSetup,
    v2ModelHomes,
    v2Neighborhoods,
    v2Options,
    v2Parts,
    v2PhotoApproval,
    v2Plans,
    v2Possessions,
    v2ProductionChecklists,
    v2ProductionPunchlists,
    v2Reports,
    v2ScheduleTemplates,
    v2ShowBuildTools,
    v2Specs,
    v2Users,
    v2ShowTradePartnerContracts,
    v2SiteReports,
    zendeskAndHelpTools,
    entraId,
    salesClosingCalendar,
    underContract,
    clientViewBuild,
    clientBuildCreation,
    fwtManagement,
    contractMarkUp,
    homeownerClosingCeremonies,
    closingDateSageOverwrite,
    salesDigitalContracting,
    documentationBuildDocumentation,
    uniformLoginPage,
    unifiedUserManagement,
    bulkOptionExclusions,
    selectsPageSlidingMenus,
    salesTestBuild,
    salesAgentLookup,
    salesIncentiveRepeater,
    entraUserCreationOrigin,
    hidePlaceOrderPage,
    convertToEntraButton,
    createReturnPoButton,
    lotPremiumOptionDepositCalculation,
    manageAppRolesPage,
    authorizeUserNavigationAccess,
    fwtPlanMarkup,
    homeownerPortalV2,
    buildCommunicationsPage,
    warrantyQuestionPage
  };
};
